<template>
  <div class="inputLabel d-flex justify-content-between atm-rounded items-align-center mt-3" >
    <label
      class="mb-0 px-3 flex-grow overflow-hidden atm-rounded"
      :class="{ 'text-secondary': !fileValue }"
    >
      {{ fileValue ? fileValue.name : 'Choose a file' }}
    </label>
    <label class="bg-main text-light text-uppercase atm-rounded text-center px-3 mb-0 cursor">
      <input 
        type="file" 
        accept="image/x-png,image/gif,image/jpeg" 
        id="file-small"
        class="text-truncate nestedInput"
        ref="fileValue"
        @change="saveFile"
      />
      Browse
    </label>
  </div>
</template>
<script>
export default {
  props: {
    file: {},
    fileInput: {},
    imageMaxSize: Number,
    error: {},
  },
  data() {
    const base64Encode = data =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    return {
      base64Encode,
    };
  },
  computed: {
    fileValue: {
      get: function() { 
        return this.fileInput;
      },
      set: function(newValue) {
        const errorReturn = {
            value: false,
            type: 'file',
            message: ''
          }
        if (newValue.size < this.imageMaxSize) {
          this.base64Encode(newValue).then(result => {
            this.$emit('update:fileData', result);
          });
          this.$emit('update:fileInput', newValue);
          this.$emit('update:error', errorReturn);
        } else {
          errorReturn.value = true;
          errorReturn.message = `THE IMAGE IS TOO LARGE TO UPLOAD MAX SIZE: ${this.imageMaxSize/1000000}`;
          this.$emit('update:error', errorReturn);
        }
      } 
    },
  },
  methods: {
    saveFile(event) {
      this.fileValue = event.target.files[0];
    },
  }
};
</script>
<style lang="scss" scoped>
.inputLabel {
  background-color: #f3f3f3;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: var(--atm-rounded);
  box-shadow: 2px 2px 6px rgb(0 0 0 / 25%);
  .nestedInput {
    display: none;
  }
}

.flex-grow {
  flex-grow: 1;
}

</style>